const APISupplyPlanRequest = {};

APISupplyPlanRequest["getAllSupplyPlanBySiteId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/supply-plan/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["getSupplyPlanById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/supply-plan/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["getProductDeliveryBySPIdAndCId"] = async (accessToken, sid, cid) => {
	try {
		const response = await fetch('/api/product-delivery/supply-plan/' + sid + '/cluster/' + cid, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["getAllProductDeliveriesBySupplyPlanId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/product-delivery/supply-plan/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["getProductDeliveryBydeliveryId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/product-delivery/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["getAllFarmerCommitmentsBySupplyId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/farmer-commitment/supply-plan/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// APISupplyPlanRequest["getAllProductDeliveriesBySupplyId"] = async (accessToken, id) => {
// 	try {
// 		const response = await fetch('/api/product-delivery/supply-plan/' + id, {
// 			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
// 		if(!response.statusText) {
// 			throw Error(response.statusText);
// 		}
// 		const body = await response.json();
// 		return(body)
// 	}
// 	catch(error) {
// 		console.log(error);
// 		return(null);
// 	}
// }

APISupplyPlanRequest["getProductDeliveryById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/product-delivery/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["getFarmerCommitmentsByClusterInvolvementId"] = async (accessToken, ciid) => {
	try {
		const response = await fetch(`/api/farmer-commitment/cluster-involvement/${ciid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["getDeliveryDetailsByClusterInvolvementId"] = async (accessToken, ciid) => {
	try {
		const response = await fetch(`/api/product-delivery/cluster-involvement/${ciid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["addFarmerCommitmentsByClusterInvolvementId"] = async (accessToken, data, ciid) => {
	try {
		const response = await fetch(`/api/farmer-commitment/cluster-involvement/${ciid}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["addDeliveryDetailsByClusterInvolvelemtnId"] = async (accessToken, data, ciid) => {
	try {
		const response = await fetch(`/api/product-delivery/cluster-involvement/${ciid}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["addSupplyPlan"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/supply-plan', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["addProductDelivery"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/product-delivery', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["addFarmerCommitmentsBySPId"] = async (accessToken, data, spid) => {
	try {
		console.log("APISupplyPlanRequest[addFarmerCommitmentsBySPId ")
		console.log(accessToken)
		console.log(spid)
		console.log(data)
		const response = await fetch('/api/farmer-commitment/supply-plan/' + spid, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["editSupplyPlanById"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/supply-plan/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["editProductDeliveryById"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/product-delivery/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["editFarmerCommitmentsBySPId"] = async (accessToken, data, spid) => {
	try {
		console.log("APISupplyPlanRequest[addFarmerCommitmentsBySPId ")
		console.log(accessToken)
		console.log(spid)
		console.log(data)
		const response = await fetch('/api/farmer-commitment/supply-plan/' + spid, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["editFarmerCommitmentsByClusterInvolvementId"] = async (accessToken, data, ciid) => {
	try {
		const response = await fetch(`/api/farmer-commitment/cluster-involvement/${ciid}`, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["editDeliveryDetailsByClusterInvolvelemtnId"] = async (accessToken, data, ciid) => {
	try {
		const response = await fetch(`/api/product-delivery/cluster-involvement/${ciid}`, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APISupplyPlanRequest["editProductDeliveryById"] = async (accessToken, data, pdid) => {
	try {
		const response = await fetch(`/api/product-delivery/${pdid}`, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APISupplyPlanRequest
